import { redirect as routerRedirect } from 'redux-first-router';
import { selectors } from 'app-webtech-core';

export const redirect = ({ type, query = {}, ...extraArgs }) => (dispatch, getState) => {
  const { query: existingQuery } = selectors.location.properties(getState());
  return dispatch(
    routerRedirect({
      ...extraArgs,
      type,
      meta: {
        query: {
          ...existingQuery,
          ...query,
        },
      },
    }),
  );
};
